import React from 'react';
import { useNavigate } from 'react-router-dom';
import './empty-state.css';

/**
 * Ortak bos ekran (Yonlendirme Faz 3.1): ikon + baslik + kisa aciklama + tek
 * buton. Liste gercekten bossa buton kullaniciyi bir sonraki adima goturur
 * (ornegin "Firma Ekle"); filtre/arama sonuc vermediyse yalnizca metin ve
 * gerekirse "Filtreleri temizle" gosterilir.
 */

export type EmptyStateAction = {
    label: string;
    /** Gidilecek sayfa. `onClick` ile birlikte verilmez. */
    to?: string;
    /** Sayfa ici islem (ornegin yeni sohbet penceresini acmak). */
    onClick?: () => void;
    icon?: string;
};

type EmptyStateProps = {
    /** Font Awesome sinifi, ornegin "fa-regular fa-calendar-xmark". */
    icon: string;
    title: string;
    description?: string;
    action?: EmptyStateAction | null;
    /** Dar alanlar (modal, kenar paneli) icin daha kucuk gorunum. */
    compact?: boolean;
    className?: string;
};

const EmptyState = ({ icon, title, description, action, compact = false, className = '' }: EmptyStateProps) => {
    const navigate = useNavigate();

    const handleAction = () => {
        if (!action) return;
        if (action.onClick) action.onClick();
        else if (action.to) navigate(action.to);
    };

    return (
        <div className={`beetinq-empty-state${compact ? ' is-compact' : ''} ${className}`.trim()} role="status">
            <span className="beetinq-empty-state-icon" aria-hidden="true">
                <i className={icon} />
            </span>
            <p className="beetinq-empty-state-title">{title}</p>
            {description ? <p className="beetinq-empty-state-text">{description}</p> : null}
            {action ? (
                <button type="button" className="beetinq-empty-state-action" onClick={handleAction}>
                    {action.icon ? <i className={action.icon} aria-hidden="true" /> : null}
                    {action.label}
                </button>
            ) : null}
        </div>
    );
};

export default EmptyState;
